import { render } from "./SearchFilter.vue?vue&type=template&id=1c67760e&ts=true"
import script from "./SearchFilter.vue?vue&type=script&lang=ts"
export * from "./SearchFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__